const CLOSED_JOB_STATUSES = ['closed/lost', 'closed/won'] as const;

export const CLOSED_JOB_STATUSES_FILTER = `(${CLOSED_JOB_STATUSES.join(',')})`;

export const isClosedJobStatusValue = (status?: string | null): boolean => {
	if (!status)
		return false;

	return CLOSED_JOB_STATUSES.includes(status as typeof CLOSED_JOB_STATUSES[number]);
};